module.exports = __webpack_public_path__ + "static/media/undraw.ae4c808c.svg";